import * as React from "react";
import { Button, Create, ReferenceInput, required, SelectInput, TextInput, Toolbar, useNotify } from "react-admin";
import { TitleHomebaseComponent } from "./Constant/Constant";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { CircularProgress, Grid } from "@material-ui/core";
import { Form } from "react-final-form";
import { Add } from "@material-ui/icons";
import { useAppDataProvider } from "../../../dataprovider";
import { useHistory } from "react-router-dom";

const HomebaseComponentFormContent: React.FC<{
  handleSubmit: any;
  form: any;
  values: any;
  createLoading: boolean;
  props: any;
  onFailure: (error: any) => void;
  onChangeCustomer: (form: any) => void;
}> = ({ handleSubmit, form, values, createLoading, props, onFailure, onChangeCustomer }) => {
  React.useEffect(() => onChangeCustomer(form), [values?.customerId]);

  return (
    <form>
      <>
        <Create {...props} title={TitleHomebaseComponent.create} onFailure={onFailure}>
          <Grid container spacing={2} style={{ width: "100%", padding: 30 }}>
            <Grid item xs={12} sm={6}>
              <ReferenceInput
                label="Customer"
                source="customerId"
                reference={SourceCustomer}
                sort={{ field: "id", order: "ASC" }}
                validate={[required()]}
                fullWidth
                variant="outlined"
              >
                <SelectInput optionValue="id" optionText="customerName" />
              </ReferenceInput>
              <TextInput source="pn" validate={[required()]} fullWidth variant="outlined" />
              <TextInput source="condition" validate={[required()]} fullWidth variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ReferenceInput
                disabled={!(values.customerId > 0)}
                label="Warehouse"
                source="warehouseId"
                reference={"homebasewarehouses"}
                filter={{ customerId__eq: values.customerId ?? null }}
                sort={{ field: "id", order: "ASC" }}
                validate={[required()]}
                fullWidth
                variant="outlined"
              >
                <SelectInput optionValue="id" optionText="location" />
              </ReferenceInput>
              <TextInput source="sn" validate={[required()]} fullWidth variant="outlined" />
            </Grid>
            <Toolbar
              {...props}
              placeholder=""
              style={{
                display: "flex",
                justifyContent: "end",
                width: "100%",
              }}
            >
              <Button
                label={createLoading ? "Creating!" : "Create"}
                size="medium"
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                {createLoading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
              </Button>
            </Toolbar>
          </Grid>
        </Create>
      </>
    </form>
  );
};

const HomebaseComponentCreate = props => {
  const notify = useNotify();
  const history = useHistory();
  const dataProvider = useAppDataProvider();
  const [createLoading, setCreateLoading] = React.useState<boolean>(false);
  const onFailure = error => notify(error?.response?.data, { type: "warning" });

  const onChangeCustomer = form => {
    console.log(form);
    form.change("warehouseId", null);
  };

  const onSubmit = values => {
    if (createLoading) {
      return;
    }
    setCreateLoading(true);
    dataProvider
      .createHomeBaseComponent(values)
      .then(response => {
        notify(`Record created`, "success", false, true);
        history.push("/homebasecomponents");
      })
      .catch(response => {
        notify(`${response}`, "error", false, true);
      })
      .finally(() => {
        setCreateLoading(false);
      });
  };
  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, form, values }) => (
        <HomebaseComponentFormContent
          handleSubmit={handleSubmit}
          form={form}
          values={values}
          createLoading={createLoading}
          props={props}
          onFailure={onFailure}
          onChangeCustomer={onChangeCustomer}
        />
      )}
    />
  );
};

export default HomebaseComponentCreate;
